import { render, staticRenderFns } from "./GzhSet.vue?vue&type=template&id=4728d282&"
import script from "./GzhSet.vue?vue&type=script&lang=js&"
export * from "./GzhSet.vue?vue&type=script&lang=js&"
import style0 from "./GzhSet.vue?vue&type=style&index=0&id=4728d282&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports